import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState } from '../../models/authentication.model';

export const selectAuthState = createFeatureSelector<AuthState>('auth');

export const selectAuthAfUser = createSelector(selectAuthState, (state) => state.afUser);
export const selectAuthUserData = createSelector(selectAuthState, (state) => state.user);
export const selectAuthUserPermissions = createSelector(selectAuthUserData, (state) => state ? state.permissions : null);
export const selectAuthUserPreferences = createSelector(selectAuthUserData, (state) => state ? state.preferences : null);
export const selectAuthIsLogged = createSelector(selectAuthState, (state) => state.isLogged);
export const selectAuthLoading = createSelector(selectAuthState, (state) => state.loading);
export const selectAuthLoaded = createSelector(selectAuthState, (state) => state.loaded);
export const selectAuthError = createSelector(selectAuthState, (state) => state.error);
export const selectAuthGCMLoaded = createSelector(selectAuthState, (state) => state.gcm_loaded);
